import React, { FC, Fragment, useState } from 'react';
import OrdersPageActions from 'components/orders/shared/orders-page-actions.component';
import { OrderFilter, OrderStatus } from 'models/order';
import { Grid, Box } from '@mui/material';
import StatusColumn from 'components/orders/order-status-view/status-column.component';
import { permissions } from 'utils/permission';
import { currentUserVar } from 'apollo/reactive-variables/user';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const OrderStatusViewTab: FC = () => {
    const { t: translate } = useTranslation(['orders']);
    const currentUser = currentUserVar();
    const [orderFilters, setOrderFilters] = useState<OrderFilter>(
        JSON.parse(localStorage.getItem('order-list-filters') || '{}'),
    );

    const handleFilterChange = (filters: OrderFilter) => {
        setOrderFilters(filters);
    };

    return (
        <Fragment>
            <Helmet>
                <title>{translate('orders:STATUS_VIEW')} | Denthub</title>
            </Helmet>
            <Box mb={1}>
                <OrdersPageActions
                    initFilters={orderFilters}
                    onFilterChange={handleFilterChange}
                    hideStatusFilter={true}
                    hideProductionFilter={true}
                    hideOrderTagFilter={true}
                    hideSupplierFilter={true}
                />
            </Box>
            <Grid container spacing={1}>
                <Grid item sm={3}>
                    <StatusColumn statusStep={OrderStatus.SENT_BY_CUSTOMER} filters={orderFilters} />
                </Grid>
                <Grid item sm={3}>
                    <StatusColumn statusStep={OrderStatus.ACCEPTED_BY_LAB} filters={orderFilters} />
                </Grid>
                <Grid item sm={3}>
                    <StatusColumn statusStep={OrderStatus.SENT_BY_LAB} filters={orderFilters} />
                </Grid>
                {permissions.isDentist(currentUser.type) ? (
                    <Grid item sm={3}>
                        <StatusColumn statusStep={OrderStatus.ORDER_APPROVED} filters={orderFilters} />
                    </Grid>
                ) : undefined}
                {permissions.isLabTechnician(currentUser.type) ? (
                    <Grid item sm={3}>
                        <StatusColumn statusStep={OrderStatus.CANCELLED} filters={orderFilters} />
                    </Grid>
                ) : undefined}
            </Grid>
        </Fragment>
    );
};

export default OrderStatusViewTab;
